import {
  UserEndPoints,
  OAuth2_MakeRequestAndGetResponse,
  OAuth2_MakeRequestAndGetResponseLogin,
} from "./index";
import { HTTPOperationType } from "./httpOperations";
import {
  GetBaseURL,
  GetReportBaseURL,
  PaymentsEndPoints,
  BonusEndPoints,
  BonusRequestEndPoints,
  WithdrawRequestEndPoints
} from "./_serviceSettings";
import Emitter from "_actions/emitter";
import moment from "moment";
import toast from "react-hot-toast";
export const UserService = {
  USER_DETAIL,
  GET_CURRENCY,
  GET_MY_HISTORY,
  READ_TICKETS,
  GET_MY_ACCOUNT_HISTORY,
  UPDATE_PASSWORD,
  REGISTER,
  GET_AVAIABLE_SETTING,
  GET_USERLIMITS,
  GET_PREVIEW_USD,
  GET_ASSETS,
  CREATE_PAYMENT,
  GET_PAYMENT_STATUS,
  GET_BONUS_BALANCE_DETAIL,
  CREATE_BONUS_REQUEST,
  GET_MY_BONUS_REQUESTS,
  CANCEL_BONUS_REQUEST,
  CREATE_WITHDRAW_REQUEST,
  GET_MY_WITHDRAW_REQUESTS,
  CANCEL_WITHDRAW_REQUEST

};

async function USER_DETAIL() {
  return OAuth2_MakeRequestAndGetResponse(
    (await GetReportBaseURL()) + UserEndPoints.GET_USERDETAIL,
    HTTPOperationType.post,
    {},
  )
    .then((res) => {
      try {
        if (res.operationResult && res?.dynamicValue?.SetPasswordNeed) {
          //Kaldıralım dediler yapı hazır
          //Emitter.emit("UPDATE_PASS", true);
        }
      } catch (error) {}

      return Promise.resolve(res.dynamicValue);
    })
    .catch((err) => {
      /* if (toast) {
        toast.error("You have not permission");
      }
      */
      return Promise.reject(err);
    });
}

async function UPDATE_PASSWORD(password) {
  return OAuth2_MakeRequestAndGetResponse(
    (await GetBaseURL()) + UserEndPoints.UPDATE_PASSWORD,
    HTTPOperationType.post,
    {
      Password: password,
      RePassword: password,
    },
  )
    .then((res) => {
      return Promise.resolve(res.dynamicValue);
    })
    .catch((err) => {
      /* if (toast) {
        toast.error("You have not permission");
      }
      */
      return Promise.reject(err);
    });
}

async function READ_TICKETS(
  page = 1,
  search,
  type,
  begin = new Date(moment().startOf("day").add(1, "seconds")).toJSON(),
  end = new Date(moment().endOf("day").subtract(1, "seconds")).toJSON(),
) {
  const _type = `"TicketStatus": { "$regex": "${type}","$options":"i" }`;
  const _search = `"TicketID": { "$regex": "${search}","$options":"i" }`;
  const _date = `"CreateTime": { "$gte": "${begin}", "$lt": "${end}" }`;

  let _filter = "";

  if (search) {
    _filter = _filter + (_filter.length > 0 ? "," : "") + _search;
  }
  if (type) {
    _filter = _filter + (_filter.length > 0 ? "," : "") + _type;
  }
  if (begin && end) {
    _filter = _filter + (_filter.length > 0 ? "," : "") + _date;
  }

  const path = `{${_filter}}?CountPerPage=100&CurrentPage=${page}&Sorts=_id=-1`;

  return OAuth2_MakeRequestAndGetResponse(
    (await GetBaseURL()) + UserEndPoints.READ_TICKETS + path,
    HTTPOperationType.get,
  )
    .then((res) => {
      return Promise.resolve(res.dynamicValue);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

async function GET_CURRENCY() {
  return OAuth2_MakeRequestAndGetResponse(
    (await GetBaseURL()) +
      UserEndPoints.READ_CURRENCY +
      UserEndPoints.READ_DEFAULT_FILTER,
    HTTPOperationType.get,
  )
    .then((res) => {
      return Promise.resolve(res.dynamicValue);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

async function GET_MY_HISTORY(
  page = 1,
  search,
  type,
  begin = new Date(moment().startOf("day").add(1, "seconds")).toJSON(),
  end = new Date(moment().endOf("day").subtract(1, "seconds")).toJSON(),
) {
  const _type = `"RelFinancialType": "${type}" `;
  const _search = `"TicketID": { "$regex": "${search}","$options":"i" }`;
  const _date = `"OperationTime": { "$gte": "${begin}", "$lt": "${end}" }`;

  let _filter = "";

  if (search) {
    _filter = _filter + (_filter.length > 0 ? "," : "") + _search;
  }
  if (type) {
    _filter = _filter + (_filter.length > 0 ? "," : "") + _type;
  }
  if (begin && end) {
    _filter = _filter + (_filter.length > 0 ? "," : "") + _date;
  }
  const path = `{${_filter + `,"Amount": { "$ne": 0 }`}}?CountPerPage=25&CurrentPage=${page}&Sorts=OperationTime=-1`;

  return OAuth2_MakeRequestAndGetResponse(
    (await GetReportBaseURL()) + UserEndPoints.READ_GAME_HISTORIES + path,
    HTTPOperationType.get,
  )
    .then((res) => {
      return Promise.resolve(res.dynamicValue);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

async function GET_MY_ACCOUNT_HISTORY(
  page = 1,
  begin = new Date(moment().startOf("day").add(1, "seconds")).toJSON(),
  end = new Date(moment().endOf("day").subtract(1, "seconds")).toJSON(),
) {
  const _type = `"RelFinancialType": {"$in": ["65ce8136bda5999c06dc4880", "65d279773029d7bfab4930a4"]} `;
  const _date = `"OperationTime": { "$gte": "${begin}", "$lt": "${end}" }`;

  let _filter = "";

  _filter = _filter + (_filter.length > 0 ? "," : "") + _type;

  if (begin && end) {
    _filter = _filter + (_filter.length > 0 ? "," : "") + _date;
  }
  const path = `{${_filter}}?CountPerPage=25&CurrentPage=${page}&Sorts=_id=-1`;

  return OAuth2_MakeRequestAndGetResponse(
    (await GetReportBaseURL()) + UserEndPoints.READ_GAME_HISTORIES + path,
    HTTPOperationType.get,
  )
    .then((res) => {
      return Promise.resolve(res.dynamicValue);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

async function REGISTER(payload) {
  const aa = (await GetReportBaseURL()) + UserEndPoints.REGISTER;

  return OAuth2_MakeRequestAndGetResponseLogin(
    aa,
    HTTPOperationType.post,
    payload,
  )
    .then((res) => {
      return Promise.resolve(res);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

async function GET_AVAIABLE_SETTING() {
  return OAuth2_MakeRequestAndGetResponse(
    (await GetReportBaseURL()) + UserEndPoints.GET_AVAIABLE_SETTING,
    HTTPOperationType.get,
  )
    .then((res) => {
      return Promise.resolve(res.dynamicValue);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

async function GET_USERLIMITS(id) {
  return OAuth2_MakeRequestAndGetResponse(
    (await GetBaseURL()) + UserEndPoints.GET_USERLIMITS,
    HTTPOperationType.get,
  )
    .then((res) => {
      return Promise.resolve(res.dynamicValue);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

async function GET_ASSETS() {
  return OAuth2_MakeRequestAndGetResponse(
    (await GetBaseURL()) + PaymentsEndPoints.GET_ASSESTS,
    HTTPOperationType.get,
  )
    .then((res) => {
      return Promise.resolve(res.dynamicValue);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

async function GET_PREVIEW_USD(amount) {
  return OAuth2_MakeRequestAndGetResponse(
    (await GetBaseURL()) + PaymentsEndPoints.GET_PREVIEW_USD + amount,
    HTTPOperationType.get,
  )
    .then((res) => {
      return Promise.resolve(res.dynamicValue);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

async function CREATE_PAYMENT(amount, asset, network) {
  let js = {
    amount: amount, // 5,
    asset: asset, //"USDT",
    network: network, //"TRC20",
  };
  return OAuth2_MakeRequestAndGetResponse(
    (await GetBaseURL()) + PaymentsEndPoints.CREATE_PAYMENT,
    HTTPOperationType.post,
    js,
  )
    .then((res) => {
      return Promise.resolve(res.dynamicValue);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

async function GET_PAYMENT_STATUS(paymentId) {
  return OAuth2_MakeRequestAndGetResponse(
    (await GetBaseURL()) + PaymentsEndPoints.GET_STATUS + paymentId,
    HTTPOperationType.get,
  )
    .then((res) => {
      return Promise.resolve(res.dynamicValue);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

async function GET_BONUS_BALANCE_DETAIL(gamerId) {
  const path = `?userId=${gamerId}`;

  return OAuth2_MakeRequestAndGetResponse(
    (await GetBaseURL()) + BonusEndPoints.BALANCE_DETAIL + path,
    HTTPOperationType.get,
  )
    .then((res) => {
      return Promise.resolve(res.dynamicValue);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

async function CREATE_BONUS_REQUEST(message, suggestedAmount) {
  return OAuth2_MakeRequestAndGetResponse(
    (await GetBaseURL()) + BonusRequestEndPoints.CREATE,
    HTTPOperationType.post,
    {
      message: message,
      suggestedAmount: suggestedAmount,
    },
  )
    .then((res) => {
      return Promise.resolve(res.dynamicValue);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

async function GET_MY_BONUS_REQUESTS() {
  return OAuth2_MakeRequestAndGetResponse(
    (await GetBaseURL()) + BonusRequestEndPoints.MY,
    HTTPOperationType.get,
  )
    .then((res) => {
      return Promise.resolve(res.dynamicValue);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

async function CANCEL_BONUS_REQUEST(requestId) {
  return OAuth2_MakeRequestAndGetResponse(
    (await GetBaseURL()) + BonusRequestEndPoints.CANCEL,
    HTTPOperationType.post,
    {
      requestId: requestId,
    },
  )
    .then((res) => {
      return Promise.resolve(res.dynamicValue);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

async function CREATE_WITHDRAW_REQUEST(amount) {
  return OAuth2_MakeRequestAndGetResponse(
    (await GetBaseURL()) + WithdrawRequestEndPoints.CREATE,
    HTTPOperationType.post,
    {
      amount: amount,
    },
  )
    .then((res) => {
      return Promise.resolve(res.dynamicValue);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

async function GET_MY_WITHDRAW_REQUESTS() {
  return OAuth2_MakeRequestAndGetResponse(
    (await GetBaseURL()) + WithdrawRequestEndPoints.MY,
    HTTPOperationType.get,
  )
    .then((res) => {
      return Promise.resolve(res.dynamicValue);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

async function CANCEL_WITHDRAW_REQUEST(requestId) {
  return OAuth2_MakeRequestAndGetResponse(
    (await GetBaseURL()) + WithdrawRequestEndPoints.CANCEL,
    HTTPOperationType.post,
    {
      requestId: requestId,
    },
  )
    .then((res) => {
      return Promise.resolve(res.dynamicValue);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}